import React from 'react';
import PropTypes from 'prop-types';
import ReportBox from '../../components/ReportBox';
import Gauge from '../../components/Gauge';

const BusinessProductivity = ({ value }) => (
  <ReportBox title="Business Productivity" automationId="text:businessProductivityHeader">
    <Gauge value={value} label={`${value}%`} automationId="businessProductivity" />
  </ReportBox>
);

BusinessProductivity.propTypes = {
  value: PropTypes.number.isRequired,
};

export default BusinessProductivity;
